import { PROCESSOR_TYPES, type ProcessorInfo } from 'features/VirtualBackground/types';

interface BackgroundsManifestObjectDto {
    name: string;
    last_modified_utc: string;
}

export interface BackgroundsManifestDto {
    objects: BackgroundsManifestObjectDto[];
    preview_prefix: string;
    full_prefix: string;
}

export const mapBackgroundsManifest = (
    manifest: BackgroundsManifestDto,
    prefix: string,
): Map<string, ProcessorInfo> => {
    return manifest.objects.reduce((acc, object) => {
        const filename = object.name;
        acc.set(filename, {
            type: PROCESSOR_TYPES.image,
            previewSrc: `${prefix}${manifest.preview_prefix}${filename}`,
            fullSrc: `${prefix}${manifest.full_prefix}${filename}`,
        });
        return acc;
    }, new Map<string, ProcessorInfo>());
};
